import { lazy, useRef, useState } from "react";
import { Box, Modal, Paper, Zoom } from "@mui/material";
import PropTypes from "prop-types";

import StepButtons from "src/components/buttons/StepButtons/StepButtons";
import { useOutsideClick } from "src/context/useOutsideClick";
import LazyLoader from "src/components/layout/Progress/LazyLoader";

const _infoBox = import("./InfoBox");
const InfoBox = lazy(() => _infoBox);

function HelperModal(props) {
  const [showSuljeButton, setShowSuljeButton] = useState(true);
  const allowEdit = props.allowEdit;
  const onSuljeButtonChange = (value) => setShowSuljeButton(value);
  const containerRef = useRef();
  useOutsideClick(
    containerRef, // ref to DOM node
    props.onSulje, // callback if clicked outside
    true // listen for clicks outside, don't listen if false
  );

  var helpId = props.helpId || "noHelpInfo";

  return (
    <>
      <Modal
        sx={{
          position: "fixed",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
          flexShrink: "0",
          flexFlow: "row wrap",
        }}
        onClick={
          allowEdit
            ? function () {
                return false;
              }
            : props.onSulje
        }
        open={props.isModalOpen}
        slotProps={{ timeout: 1500 }}
        aria-labelledby="modal-helper-title"
        aria-describedby="modal-helper-description">
        <Box className="dialog" ref={containerRef}>
          <Zoom in={props.isModalOpen}>
            <Paper elevation={2} sx={{ padding: "20px" }}>
              <LazyLoader>
                {helpId === "noHelpInfo" ? (
                  <>HELPID PUUTTUU</>
                ) : (
                  <InfoBox
                    helpId={helpId}
                    onShowSuljeButtonChange={onSuljeButtonChange}
                    allowEdit={allowEdit}
                  />
                )}
                {showSuljeButton && <StepButtons onCloseKlik={props.onSulje}>SULJE</StepButtons>}
              </LazyLoader>
            </Paper>
          </Zoom>
        </Box>
      </Modal>
    </>
  );
}
export default HelperModal;

HelperModal.propTypes = {
  helpId: PropTypes.string,
  isModalOpen: PropTypes.bool,
  onSulje: PropTypes.func,
  allowEdit: PropTypes.bool,
};
